<template>
  <ConfirmPopUp
      :dialogOpen="confirmDialog"
      :text="`Bist du sicher, dass du Aufgabe #${selectedID} löschen willst?`"
      cancel-text="Nein"
      confirm-text="Ja"
      title="Sicher?"
      @confirm="removeFeedback"
      @update:dialogOpen="(value) => confirmDialog = value"
  />
  <v-container class="pa-0" fluid>
    <!--InteractiveButton text="Aufgabe hinzufügen" @click="addAufgabe" icon="mdi-plus"
                       background-class="bg_color_pro-rot" :disabled="readonly">
    </InteractiveButton-->
    <v-btn v-if="!readonly" @click="addAufgabe">
      <v-icon start>mdi-plus</v-icon>
      Hinzufügen
    </v-btn>
    <div v-if="!readonly" class="mt-4"></div>
    <v-expansion-panels variant="popout">
      <transition-group name="fade-feedback">
        <v-expansion-panel
            v-for="(panel, index) in panels"
            :key="index"
            :style="`border-left: 4px solid ${getGroupFromName(panel.work_group).colorcode};`"
        >
          <v-expansion-panel-title class="d-flex">
            <v-col>
              <v-row class="pa-2">
                <span>Aufgabe {{ index + 1 }}</span>
              </v-row>
              <v-row class="pa-0">
                <span class="ml-2 text-primary"> Status: {{ panel.state }}</span>
              </v-row>
            </v-col>
            <v-spacer></v-spacer>
            <span v-if="!isStartable(record, panel.id)"
                  class="ml-2 color_error pr-2"> Vorherige Aufgabe ist nicht beendet!</span>
            <v-btn v-if="!readonly" :disabled="readonly" color="red" variant="plain" @click.stop="tryRemove(panel.id)">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </v-expansion-panel-title>

          <v-expansion-panel-text>
            <TaskInformationDialog v-if="record.tasks[index]" v-model="record.tasks[index]"
                                     :readonly="isReadonly"/>
          </v-expansion-panel-text>
        </v-expansion-panel>
      </transition-group>
    </v-expansion-panels>
  </v-container>
</template>

<script lang="ts" setup>

import {computed, reactive, ref, shallowRef, watch} from "vue";
import {Task, Order, getGroupFromName, Groups, isStartable, State} from "@/types/Order";
import ConfirmPopUp from "@/components/misc/ConfirmPopUp.vue";
import {VForm} from "vuetify/components";
import TaskInformationDialog from "@/components/dialogs/TaskInformationDialog.vue";
import {useGlobalSetting} from "@/lib/utils";

const selectedID = ref<number>(-1);
const confirmDialog = ref<boolean>(false);
const currentAufgabenTab = shallowRef<string>('tab-1')

const formRefs = ref<InstanceType<typeof VForm>[]>([]);

const globalSettings = useGlobalSetting();

interface AufgabenTab {
  icon: string;
  text: string;
  value: string;
}

const aufgabenTabs: AufgabenTab[] = [
  {
    icon: 'mdi mdi-information-slab-box',
    text: 'Aufgabe',
    value: 'tab-1'
  },
  {
    icon: 'mdi mdi-reply',
    text: 'Rückmeldung',
    value: 'tab-2'
  }
]

/*const props = defineProps<{
  dataSet: Auftrag
}>();*/

const record = defineModel<Order>();

defineProps({
  readonly: {
    type: Boolean,
    default: false,
  }
});

const panels = reactive<Task[]>(record.value.tasks);

const emit = defineEmits(["updateChangeList", "updateDeletedList"])

const addAufgabe = () => {
  const p = reactive<Task>({
    id: record.value.tasks.length + 1,
    order_id: record.value.id,
    title: "",
    description: "",
    author: "",
    assignee: null,
    work_group: record.value.workGroup,
    state: State.anfo,
    priority: "3",
    sequence: record.value.tasks.length + 1,
    is_lockout: false,
    asset_id: null,
    outage_code: null,
    scheduled_start: null,
    scheduled_end: null,
    scheduled_duration: null,
    feedbacks: [],
  });
  panels.push(p);
  addWatcher(p);
};

const tryRemove = (id: number) => {
  selectedID.value = id;
  confirmDialog.value = true;
}

const removeFeedback = () => {
  const index = panels.findIndex(p => p.id == selectedID.value);
  emit("updateDeletedList", panels[index]);
  panels.splice(index, 1);
  confirmDialog.value = false;
};

const addWatcher = (panel: Task): void => {
  watch(panel, (p) => {
    emit('updateChangeList', panel);
  })
}

panels.forEach(panel => {
  addWatcher(panel)
})

function isHighlighted(aufgabe: Task): boolean {
  const perm = getGroupFromName(aufgabe.work_group).permission;
  if (globalSettings.currentGroup.permission < perm) {
    return true;
  } else if (globalSettings.currentGroup.permission == perm) {
    return globalSettings.currentGroup.name != getGroupFromName(aufgabe.work_group).name;
  } else if (globalSettings.currentGroup.permission > perm) {
    return false;
  } else {
    return true;
  }
}

const isReadonly = computed(() => {
  return globalSettings.currentGroup.permission < Groups.meister.permission;
});

function validateForm() {
  if (!formRefs.value.length) return Promise.resolve(false)
  Promise.all(formRefs.value.map(f => f.validate())).then((result) => {
    return result.every(r => r.valid);
  })
}

defineExpose({validateForm});
</script>
